import { render, staticRenderFns } from "./ModalAddProfissionais.vue?vue&type=template&id=0b7a65e0"
import script from "./ModalAddProfissionais.vue?vue&type=script&lang=ts"
export * from "./ModalAddProfissionais.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports